import { useQuery } from '@tanstack/react-query';

import { listScrapingIntents, type ListScrapingIntentsParams } from '../apis';
import { scrapingQueryKeys } from './scraping-query-keys';

export function useScrapingIntents(params: ListScrapingIntentsParams) {
  return useQuery({
    queryKey: scrapingQueryKeys.intentList(params),
    queryFn: () => listScrapingIntents(params),
  });
}
